import { useTranslation } from 'react-i18next'
import { IoCreate } from "react-icons/io5";
import { OverlayTrigger, Popover } from "react-bootstrap";
import LoadingSpinner from '../../../../Components/Components/LoadingSpinner';
import useGetProductIndexWithMask from '../../../../Components/BasketPage/Hooks/useGetProductIndexWithMask';
import { CapitalizeFirstLowercaseRest, ConvertPriceToString } from '../../../../Helpers/CustomConverter';
import { OfferCurrentView } from '../../../../Data/PageModeEnums.ts';
import { useAuth } from '../../../../Providers/AuthProvider.jsx';
import { CiEdit } from "react-icons/ci";
import { useEffect } from 'react';
import { useOffers } from '../../../../Providers/OffersProvider.jsx';
import axios from 'axios';

const OfferItems = ({ items, isLoading, currentView, handleCreateOfferRequest, handleCreateRetailerOffer, offerExpiredDate, offerNo, handleEditOffer, offerSiteId }) => {
    const { t } = useTranslation()
    const { authState } = useAuth()
    const { handleChangeOfferStatus } = useOffers()

    useEffect(() => {
        const source = axios.CancelToken.source()

        if (currentView === OfferCurrentView.OfferCustomer) {
            updateStatusAfterWatch(source.token)
        }

        return () => {
            source.cancel()
        }
    }, []) //DK : po otwarciu pozycji - przeczytaniu zmieniamy status

    const updateStatusAfterWatch = async (cancelToken) => {
        await handleChangeOfferStatus(offerNo, offerSiteId, cancelToken)
    }

    const handleCreateOfferRequestButtonCLick = () => {
        let itemsToInsert = items
        itemsToInsert = items.filter(item => !item.externalArticle) //DK : Zapytanie ofertowe z pozycji oferty dla lienta - tutaj musimy usunąć pozycje własne operatora!
        handleCreateOfferRequest(itemsToInsert)
    }

    const getCreateNewOfferPopoverText = () => {
        if (authState.user.isOperator) {
            if (currentView === OfferCurrentView.OfferCustomer) {
                return 'Utwórz nową ofertę z pozycji oferty'
            }
        }
        return 'Utwórz nowe zapytanie ofertowe z pozycji oferty'
    }

    let popoverText = getCreateNewOfferPopoverText()
    const popover = <Popover id="popover-basic">
        <Popover.Body className="text-center">
            <span className='primary-accent-color-text'>{popoverText}</span>
        </Popover.Body>
    </Popover>
    const popoverNewOffer = <Popover id="popover-basic">
        <Popover.Body className="text-center">
            <span className='primary-accent-color-text'>{'Przygotuj ofertę dla klienta'}</span>
        </Popover.Body>
    </Popover>
    const editOfferPopover = <Popover id="popover-basic">
        <Popover.Body className="text-center">
            <div className='d-flex flex-column'>
                <span className='primary-accent-color-text'>Edytuj ofertę</span>
            </div>

        </Popover.Body>
    </Popover>

    return (<div className='table-responsive table-items'  >
        <table className='table table-bordered'>
            <thead>
                <tr>
                    <th style={{ alignContent: 'center', textAlign: 'left', fontWeight: 'normal', width: "9%", verticalAlign: 'middle' }}>
                        Indeks
                    </th>
                    <th style={{ alignContent: 'center', textAlign: 'left', fontWeight: 'normal', width: "auto" }}>
                        Nazwa
                        <br />
                        Cecha
                    </th>
                    {(currentView === OfferCurrentView.OfferCustomer || currentView === OfferCurrentView.OfferRequest) &&
                        <th style={{ alignContent: 'center', textAlign: 'right', fontWeight: 'normal', width: "5%", verticalAlign: 'middle' }}>
                            Rabat
                        </th>
                    }
                    {currentView === OfferCurrentView.OfferRetailer &&
                        <th style={{ alignContent: 'center', textAlign: 'right', fontWeight: 'normal', width: "5%", verticalAlign: 'middle' }}>
                            Narzut
                        </th>
                    }
                    <th style={{ alignContent: 'center', textAlign: 'right', fontWeight: 'normal', width: "10%", verticalAlign: 'middle' }}>
                        Cena netto PLN
                    </th>
                    <th style={{ alignContent: 'center', textAlign: 'right', fontWeight: 'normal', width: "6%", verticalAlign: 'middle' }}>
                        Ilość
                    </th>
                    {currentView === OfferCurrentView.OfferCustomer &&
                        <>
                            <th style={{ alignContent: 'center', textAlign: 'right', fontWeight: 'normal', width: "6%", verticalAlign: 'middle' }}>
                                Il. zam.
                            </th>

                            <th style={{ alignContent: 'center', textAlign: 'right', fontWeight: 'normal', width: "6%", verticalAlign: 'middle' }}>
                                Il. zreal.
                            </th>
                        </>
                    }
                    <th style={{ alignContent: 'center', textAlign: 'right', fontWeight: 'normal', width: "5%", verticalAlign: 'middle' }}>
                        Jedn.
                    </th>
                    <th style={{ alignContent: 'center', textAlign: 'right', fontWeight: 'normal', width: "11%", verticalAlign: 'middle' }}>
                        Wartość netto PLN
                    </th>
                    {currentView === OfferCurrentView.OfferCustomer && <th style={{ alignContent: 'center', textAlign: 'right', fontWeight: 'normal', width: "5%", verticalAlign: 'middle' }}>
                        <OverlayTrigger trigger={["hover", "focus"]} placement="bottom" overlay={popover}>
                            <span>
                                <IoCreate size={20} onClick={handleCreateOfferRequestButtonCLick} />
                            </span>
                        </OverlayTrigger>
                    </th>}
                    {currentView == OfferCurrentView.OfferCustomer && !authState.user.isOperator && <th style={{ alignContent: 'center', textAlign: 'right', fontWeight: 'normal', width: "2%", verticalAlign: 'middle' }}>
                        <OverlayTrigger trigger={["hover", "focus"]} placement="bottom" overlay={popoverNewOffer}>
                            <span>
                                <IoCreate size={20} onClick={() => handleCreateRetailerOffer(items, offerExpiredDate)} />
                            </span>
                        </OverlayTrigger>
                    </th>}
                    {currentView == OfferCurrentView.OfferRetailer && !authState.user.isOperator && <th style={{ alignContent: 'center', textAlign: 'right', fontWeight: 'normal', width: "5%", verticalAlign: 'middle' }}>
                        <OverlayTrigger trigger={["hover", "focus"]} placement="bottom" overlay={popover}>
                            <span>
                                <IoCreate size={20} onClick={handleCreateOfferRequestButtonCLick} />
                            </span>
                        </OverlayTrigger>
                    </th>}
                    {currentView == OfferCurrentView.OfferRetailer && !authState.user.isOperator && <th style={{ alignContent: 'center', textAlign: 'right', fontWeight: 'normal', width: "2%", verticalAlign: 'middle' }}>
                        <OverlayTrigger trigger={["hover", "focus"]} placement="bottom" overlay={popoverNewOffer}>
                            <span>
                                <IoCreate size={20} onClick={() => handleCreateRetailerOffer(items, offerExpiredDate)} />
                            </span>
                        </OverlayTrigger>
                    </th>}
                    {currentView === OfferCurrentView.OfferRequest && authState.user.isOperator &&
                        <th style={{ alignContent: 'center', textAlign: 'right', fontWeight: 'normal', width: "3%", verticalAlign: 'middle' }} onClick={() => handleEditOffer(items, offerNo)}>
                            <OverlayTrigger trigger={["hover", "focus"]} placement="bottom" overlay={editOfferPopover}>
                                <div>
                                    <CiEdit size={25} color='var(--primary)' />
                                </div>
                            </OverlayTrigger>
                        </th>}
                </tr>
            </thead>
            <tbody>
                {items && !isLoading && items.map((item, index) => {
                    return <OfferItem key={index} item={item} currentView={currentView} />
                })}
            </tbody>
        </table>
        {isLoading && <LoadingSpinner width={2} height={2} />}
        {!isLoading && items && items.length === 0 && (
            <div style={{ textAlign: "center" }}>
                {t("message_norecords_orders_items_page")}
            </div>
        )}
    </div>
    )
}

const OfferItem = ({ item, currentView }) => {
    const { getProductIndexWithMask } = useGetProductIndexWithMask()

    const popover = <Popover id="popover-basic">
        <Popover.Body className="text-center">
            <span className='primary-accent-color-text'>* Ceny w PLN są przeliczane z cen bazowych (walutowych) wg
                kursu sprzedaży NBP z dnia poprzedzającego wydruk oferty.
                Ceny na dokumentach sprzedażowych zostaną zaktualizowane
                wg kursu sprzedaży walut NBP w dniu poprzedzającym
                wystawienie dokumentu sprzedaży</span>
        </Popover.Body>
    </Popover>

    return (
        <tr className='hoverable-row'>
            <td style={{ alignContent: 'center', textAlign: 'left', verticalAlign: 'middle' }}>
                {getProductIndexWithMask(item.artNo)}
            </td>
            <td style={{ alignContent: 'center', textAlign: 'left', verticalAlign: 'middle' }}>
                {CapitalizeFirstLowercaseRest(item.artName)}
                <br />
                {CapitalizeFirstLowercaseRest(item.artLabel)}
            </td>
            {(currentView === OfferCurrentView.OfferCustomer || currentView === OfferCurrentView.OfferRequest) &&
                <td style={{ alignContent: 'center', textAlign: 'right', verticalAlign: 'middle' }}>
                    {`${isNaN(item.discount) ? 0 : parseFloat(item.discount).toFixed(1)} %`}
                </td>
            }
            {currentView === OfferCurrentView.OfferRetailer &&
                <td style={{ alignContent: 'center', textAlign: 'right', verticalAlign: 'middle' }}>
                    {item.priceMarkup}%
                </td>
            }
            <td style={{ alignContent: 'center', textAlign: 'right', verticalAlign: 'middle' }}>
                <div>
                    <span>{ConvertPriceToString(item.priceNet, null)}</span>
                    {item.foreignCurrency && <OverlayTrigger trigger={["hover", "focus"]} placement="bottom" overlay={popover}>
                        <span className='primary-accent-color-text'>*</span>
                    </OverlayTrigger>}
                </div>
            </td>
            <td style={{ alignContent: 'center', textAlign: 'right', verticalAlign: 'middle' }}>
                {item.qty}
            </td>
            {currentView === OfferCurrentView.OfferCustomer &&
                <>
                    <td style={{ alignContent: 'center', textAlign: 'right', verticalAlign: 'middle' }}>
                        {item.orderQty}
                    </td>

                    <td style={{ alignContent: 'center', textAlign: 'right', verticalAlign: 'middle' }}>
                        {item.realizedQty}
                    </td>
                </>
            }
            <td style={{ alignContent: 'center', textAlign: 'right', verticalAlign: 'middle' }}>
                {item.baseUnit}
            </td>
            <td style={{ alignContent: 'center', textAlign: 'right', verticalAlign: 'middle' }}>
                <div>
                    <span>{ConvertPriceToString((item.priceNet * item.qty), null)}</span>
                    {item.foreignCurrency && <OverlayTrigger trigger={["hover", "focus"]} placement="bottom" overlay={popover}>
                        <span className='primary-accent-color-text'>*</span>
                    </OverlayTrigger>}
                </div>
            </td>
        </tr>
    )
}

export default OfferItems